const SLIDER_INFO: Record<string, string> = {};
import { createActor } from 'xstate';
import { dialogMachine } from './machines/dialogMachine';
import './app-slider.css';
export function setupInfoDialogs(): void {
  const dialog = document.getElementById('info-dialog');
  const closeBtn = document.getElementById('info-close');
  const contentEl = document.getElementById('info-content');
  if (!(dialog instanceof HTMLDialogElement)) return;

  let activeInfoBtn: HTMLButtonElement | null = null;

  const infoDialogActor = createActor(dialogMachine);
  infoDialogActor.subscribe((snapshot) => {
    if (snapshot.matches('open')) {
      if (contentEl) contentEl.innerHTML = snapshot.context.content;
      dialog.showModal();
    } else {
      dialog.close();
      if (activeInfoBtn) {
        activeInfoBtn.classList.remove('active');
        activeInfoBtn = null;
      }
    }
  });
  infoDialogActor.start();

  document.querySelectorAll<HTMLButtonElement>('.slider-info-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (activeInfoBtn) activeInfoBtn.classList.remove('active');
      activeInfoBtn = btn;
      btn.classList.add('active');
      const inline = btn.dataset.infoContent;
      const key = btn.dataset.info;
      const content = inline ?? (key && SLIDER_INFO[key]) ?? '';
      infoDialogActor.send({ type: 'OPEN', content });
    });
  });

  closeBtn?.addEventListener('click', () => { infoDialogActor.send({ type: 'CLOSE' }); });

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) infoDialogActor.send({ type: 'CLOSE' });
  });
}
